/**
 * Uploads an IVR's attachments, stopping at the first failure.
 *
 * Ported from medeffectmobile/src/utils/uploadDocuments.js so the two clients
 * genuinely behave the same. Web previously caught per-file and CONTINUED:
 *
 *     } catch (uploadErr) {
 *       console.error('Upload failed, continuing without this document:', uploadErr);
 *     }
 *
 * so a failed attachment was dropped and the verification request went to the
 * payer without it, while the admin saw an ordinary success. On an insurance
 * verification the attachment is often the whole point - a Medicare card image,
 * a chart note - and the omission only surfaces days later when the request
 * comes back unprocessable. The comment above that catch claimed it matched
 * mobile; mobile had already been fixed.
 *
 * A 200 carrying no file location counts as a failure too. Accepting it pushed
 * an empty string, which the caller filtered out - the same silent drop reached
 * through the success path instead of the failure path.
 *
 * @param files      the picked File objects, in order
 * @param uploadFile async (file) => response
 * @returns {Promise<{urls: string[], failure: any|null}>}
 */
export async function uploadDocuments(files, uploadFile) {
  const urls = [];
  const list = Array.isArray(files) ? files : [];

  for (const file of list) {
    try {
      const res = await uploadFile(file);
      const url = res?.data?.data?.url || res?.data?.data?.filePath || res?.data?.url || '';
      if (!url) {
        const err = new Error('Upload returned no file location');
        err.uploadEnvelopeInvalid = true;
        return { urls, failure: err };
      }
      urls.push(url);
    } catch (err) {
      // Stop here. Continuing would upload the rest and still leave a gap,
      // which is the situation this exists to prevent.
      return { urls, failure: err };
    }
  }

  return { urls, failure: null };
}
